// extracted by css-extract-rspack-plugin
export default {"action":"action-iRkv5X"};